import React, { createContext, useContext, useEffect, useState } from "react";
import { fetchSettings } from "../lib/api";

const SiteSettingsContext = createContext(null);

// Default aligned with backend/server.py `SiteSettings`. Used until the
// /api/settings fetch resolves and as a fallback if it fails. Keeps
// SSR-like parity (the markup is not empty on first render).
const FALLBACK = {
  hotel_name: "Hotel Alpi Resort",
  address: "Via Alfonso Bonafous 5, 10123 Torino, Italia",
  address_locality: "Torino",
  address_region: "TO",
  postal_code: "10123",
  country_code: "IT",
  phone: "+39 011 123 4567",
  email: "info@hotelalpiresort.it",
  map_lat: 45.063611,
  map_lng: 7.694722,
  home_meta_title_it: "Hotel Alpi Resort — Boutique Hotel Torino Centro",
  home_meta_title_en: "Hotel Alpi Resort — Boutique Hotel in Turin City Center",
  home_meta_desc_it: "Boutique hotel raffinato nel cuore di Torino.",
  home_meta_desc_en: "A refined boutique hotel in the heart of Turin.",
  og_image_default: "/images/hotel-exterior.png",
  twitter_handle: "",
  google_site_verification: "",
  price_range: "€€€",
  social: {},
};

export function SiteSettingsProvider({ children }) {
  const [settings, setSettings] = useState(FALLBACK);

  useEffect(() => {
    let alive = true;
    fetchSettings()
      .then((s) => {
        if (alive && s) setSettings({ ...FALLBACK, ...s });
      })
      .catch(() => {
        /* silent: keep fallback */
      });
    return () => { alive = false; };
  }, []);

  return (
    <SiteSettingsContext.Provider value={settings}>
      {children}
    </SiteSettingsContext.Provider>
  );
}

export const useSettings = () => {
  const ctx = useContext(SiteSettingsContext);
  if (!ctx) throw new Error("useSettings must be used within SiteSettingsProvider");
  return ctx;
};
